<form>
  <div class="inv-main">
    <div class="add-member-side w-100">
      <span class="add-member-text">{{ 'my_team.add_new_member' | translate }}</span>
    </div>
    <div class="w-100 input-f-mat">
      <mat-form-field appearance="fill">
        <mat-label>{{ 'my_team.invite_by_email_or_username' | translate }}</mat-label>
        <mat-chip-grid #chipGrid>
          @for (member of members; track member) {
            <mat-chip [removable]="true" (removed)="remove(member)">
              {{ member }}
              <mat-icon matChipRemove>close</mat-icon>
            </mat-chip>
          }
          <input
            [formControl]="form"
            [matChipInputFor]="chipGrid"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="true"
            (matChipInputTokenEnd)="add($event)"
            autocomplete="off"
          />
        </mat-chip-grid>
      </mat-form-field>
      @if (form.hasError('emailOrId')) {
        <mat-error class="mat-error-style">
          {{ VALIDATION_ERROR_TEXT | translate }}
        </mat-error>
      }
      @if (hasMemberValidationError) {
        <mat-error class="mat-error-style">
          {{ VALIDATION_ERROR_TEXT | translate }}
        </mat-error>
      }
      @if (hasUsernameNotExistError) {
        <mat-error class="mat-error-style">
          {{ VALIDATION_ERROR_USERNAME_NOT_EXIST | translate }}
        </mat-error>
      }
      @if (isMembersEmpty && !hasUsernameNotExistError) {
        <mat-error class="mat-error-style">
          {{ VALIDATION_EMPTY_TEXT | translate }}
        </mat-error>
      }
      @if (hasInvitationAlreadySentError) {
        <mat-error>
          {{ VALIDATION_ERROR_ALREADY_SEND_TO_EMAIL_TEXT | translate }}
        </mat-error>
      }
      @if (hasAlreadyMemberError) {
        <mat-error>
          {{ VALIDATION_ERROR_ALREADY_MEMBER_TEXT | translate }}
        </mat-error>
      }
    </div>
    <div class="buttons-side w-100">
      <button mat-button class="cancel-btn" type="button" (click)="cancel()">{{ 'user_card.cancel' | translate }}</button>
      <button mat-button class="save-btn" type="submit" (click)="save()" [disabled]="form.invalid">{{ 'user_card.save' | translate }}</button>
    </div>
  </div>
</form>
